var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCaretUp = function SvgCaretUp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9906 8.60023L0.418792 2.32688C-0.139597 1.79385 -0.139597 0.932801 0.418792 0.399772C0.977181 -0.133258 1.87919 -0.133258 2.43758 0.399772L8.00716 5.70273L13.5624 0.399772C14.1208 -0.133258 15.0228 -0.133258 15.5812 0.399772C16.1396 0.932801 16.1396 1.79385 15.5812 2.32688L9.0094 8.60023C8.46532 9.13326 7.54899 9.13326 6.9906 8.60023Z",
    fill: "#B4B4B4"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCaretUp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02Ljk5MDYgOC42MDAyM0wwLjQxODc5MiAyLjMyNjg4Qy0wLjEzOTU5NyAxLjc5Mzg1IC0wLjEzOTU5NyAwLjkzMjgwMSAwLjQxODc5MiAwLjM5OTc3MkMwLjk3NzE4MSAtMC4xMzMyNTggMS44NzkxOSAtMC4xMzMyNTggMi40Mzc1OCAwLjM5OTc3Mkw4LjAwNzE2IDUuNzAyNzNMMTMuNTYyNCAwLjM5OTc3MkMxNC4xMjA4IC0wLjEzMzI1OCAxNS4wMjI4IC0wLjEzMzI1OCAxNS41ODEyIDAuMzk5NzcyQzE2LjEzOTYgMC45MzI4MDEgMTYuMTM5NiAxLjc5Mzg1IDE1LjU4MTIgMi4zMjY4OEw5LjAwOTQgOC42MDAyM0M4LjQ2NTMyIDkuMTMzMjYgNy41NDg5OSA5LjEzMzI2IDYuOTkwNiA4LjYwMDIzWiIgZmlsbD0iI0I0QjRCNCIvPgo8L3N2Zz4K";